import React from 'react';
import { Col } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import { Fields } from '../Fields';
import { Crews } from '../Crews';
import { Loads } from '../Loads';
import Offload from '../offload/OffloadDetails';

const Body = (props) => {

    return <Col className="body">
        <Switch>
            <Route exact path={`${props.match.path}/crews`} component={Crews} />
            <Route exact path={`${props.match.path}/fields`} component={Fields} />
            <Route exact path={`${props.match.path}/loads`} component={Loads} />
            <Route exact path={`${props.match.path}/offload`} component={Offload} />
        </Switch>
    </Col>;
};

export default Body;